import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo480 from "../../assets/ONCA_480.svg";

import Modal from "./Modal";

const Header = () => {
  const [isModalActive, toggleModalActive] = useState(false); 

  const handleMenuButton = () => {
    toggleModalActive(state => !state);
  }

  
  return (
    <header>
      <Modal active={isModalActive} disactivate={() => toggleModalActive(false)}/>
      <Link to="/"><Logo480 /></Link>
      <h2>Onca Development</h2>
      <nav>
        <ul>
          <li className="bottom"><Link to="/services">Services</Link></li>
          <li className="bottom"><Link to="/portfolio">Portfolio</Link></li>
          {/* <li><Link to="/about">About</Link></li> */}
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>
      <button className="material-symbols-outlined" onClick={handleMenuButton}>
        menu
      </button>
    </header>
  )
}

export default Header;